export default __webpack_public_path__ + "static/media/13.9d5b8f0c.png";